<template>
  <div class="body_monban" >
    <el-tabs  style="height: 200px;" v-model="activeName">
    <!-- <el-tab-pane label="计费模版" name="jifei"><mobanJifei></mobanJifei></el-tab-pane>
    <el-tab-pane label="分账模版" name="fenzhang"><mobanFenzhang></mobanFenzhang></el-tab-pane>
    <el-tab-pane label="包月卡充值模版" name="baoyue"><mobanBaoyueka></mobanBaoyueka></el-tab-pane> -->
    <el-tab-pane label="储值卡充值模版" name="chuzhi"><mobanChuzhika></mobanChuzhika></el-tab-pane>
  </el-tabs>

  </div>
</template>
<style>
.body_moban{
  padding-top: 100px;
}
</style>
<script>
// import mobanJifei from './mobanJifei.vue';
// import mobanFenzhang from './mobanFenzhang.vue';
// import mobanBaoyueka from './mobanBaoyueka.vue';
import mobanChuzhika from './mobanChuzhika.vue';
export default {
  components: {
    // mobanJifei: mobanJifei,
    // mobanFenzhang: mobanFenzhang,
    // mobanBaoyueka: mobanBaoyueka,
    mobanChuzhika: mobanChuzhika
  },

  data() {
    return {
      // 获取用户列表参数
      activeName: 'chuzhi'
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
